import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CepRule, SimpleCepRule } from "../../../model/cep-rule";
import { TenantsService } from "../../../services/tenants.service";
import { CepRulesService } from "../../../services/cep-rules.service";
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'cep-rules-details',
  templateUrl: './cep-rules-details.component.html',
  styleUrls: ['./cep-rules-details.component.scss']
})
export class CepRulesDetailsComponent implements OnInit {

  public cepRule: CepRule;
  public simpleRules: SimpleCepRule[];

  loadingRules: boolean;

  identifiersFirst: number;
  identifiersRows: number;

  public totalSimpleRules;
  public rows = 5;
  public first = 0;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private cepRulesService: CepRulesService,
              private tenantsService: TenantsService) {
    this.identifiersFirst = 0;
    this.identifiersRows = 5;
  }

  ngOnInit() {
    this.simpleRules = new Array(this.rows);
    this.route.url.subscribe(urlSegment => {
      this.loadCepRule(urlSegment[0].path, urlSegment[1].path, urlSegment[2].path);
    });
  }

  loadCepRule(tenantUuid: string, organization: string, nameComplexRule: string) {
    this.loadingRules = true;
    let organizationUuid = organization === 'global' ? null : organization;
    this.tenantsService.getTenantCepRule(tenantUuid, organizationUuid, nameComplexRule)
      .subscribe(response => {
      this.cepRule = response.cepRule;
      this.simpleRules = response.cepRule.simpleRules;
      this.totalSimpleRules = response.totalSimpleRules;
      this.loadEvaluations();
      this.loadingRules = false;
    }, error => {
      if (error.status == 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  private loadEvaluations() {
    let fired = true;
    this.cepRule.simpleRules.forEach((simpleRule: SimpleCepRule)=> {
      if(simpleRule.evaluationDate != undefined) {
        if(this.cepRule.evaluationDate == undefined || simpleRule.evaluationDate > this.cepRule.evaluationDate) {
          this.cepRule.evaluationDate = simpleRule.evaluationDate;
          this.cepRule.triggeredDate = simpleRule.triggeredDate;
          this.cepRule.lastValueEvaluated = simpleRule.lastValueEvaluated;
          this.cepRule.lastSensorEvaluated = simpleRule.entitiesAndSensorIdentifiers[0].measurementName;
        }
        if(simpleRule.lastEvaluation == false) {
          fired = false;
        }
      } else {
        fired = false;
      }
      this.cepRule.lastEvaluation = fired;
    });
  }
}
